<template>
  <div class="atom-file-input">
    <input :id="inputId" type="file" :accept="accept" :multiple="multiple" :disabled="disabled" class="atom-file-input__hidden" @change="handleFileChange" />
    <label :for="inputId" class="atom-file-input__label">
      <img src="https://new-web-site-bucket.s3.amazonaws.com/myspace/icons/Clip.svg" alt="clip icon" class="atom-file-input__icon" />
      <span class="atom-file-input__text">{{ displayText }}</span>
    </label>
  </div>
</template>

<script>
  export default {
    name: "AtomFileInput",
    props: {
      accept: {
        type: String,
        default: "image/*,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: "Selecciona un archivo",
      },
      selectedFile: {
        type: [File, FileList],
        default: null,
      },
    },
    emits: ["file-selected"],
    data() {
      return {
        uniqueId: Math.random().toString(36).substr(2, 9),
      };
    },
    computed: {
      inputId() {
        return `file-input-${this.uniqueId}`;
      },
      displayText() {
        if (this.selectedFile) {
          if (this.selectedFile instanceof File) {
            return this.selectedFile.name;
          } else if (this.selectedFile instanceof FileList && this.selectedFile.length > 0) {
            return this.selectedFile.length === 1 ? this.selectedFile[0].name : `${this.selectedFile.length} archivos seleccionados`;
          }
        }
        return this.placeholder;
      },
    },
    methods: {
      handleFileChange(event) {
        const files = event.target.files;
        const selectedFile = this.multiple ? files : files.length > 0 ? files[0] : null;
        this.$emit("file-selected", selectedFile);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .atom-file-input {
    display: flex;
    align-items: center;

    &__hidden {
      display: none;
    }

    &__label {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 10px 16px;
      background: #e9e9e9;
      border: 1px solid #ddd;
      border-radius: 12px;
      cursor: pointer;
      font-size: 14px;
      color: #666;
      transition: all 0.2s;

      &:hover {
        background: #e9ecef;
        border-color: #adb5bd;
      }
    }

    &__icon {
      width: 22px;
      height: 21px;
      object-fit: cover;
      color: unset;
    }

    &__text {
      flex: 1;
      white-space: nowrap;
      font-family: $newFont_medium;
      font-weight: 400;
      overflow: hidden;
      text-overflow: ellipsis;
      color: #3d3d3d;
    }
  }
</style>
